// extracted by mini-css-extract-plugin
export default {"LinkIconButton":"LinkIconButton_LinkIconButton__ahDds"};